import { defineStore } from 'pinia'
import api from '@/services/api'

export const useFavoritesStore = defineStore('favorites', {
  state: () => ({
    favorites: [],
  }),
  actions: {
    async fetchFavorites() {
      const response = await api.get('/api/v1/favorites')
      this.favorites = response.data.data
    },
    async toggleFavorite(favoritable) {
      const isFavorite = this.favorites.some(f => f?.favoritable?.id === favoritable.id && f?.type === favoritable.type)

      if (isFavorite) {
        await api.delete('/api/v1/favorites', {
          data: {
            favoritable_id: favoritable.favoritable_id,
            favoritable_type: favoritable.favoritable_type,
          },
        })
      } else {
        await api.post('/api/v1/favorites', {
          favoritable_id: favoritable.favoritable_id,
          favoritable_type: favoritable.favoritable_type,
        })
      }

      await this.fetchFavorites()
    },
  },
})
